import get from 'lodash/get';
import reducerConstant from 'common/reducerConstants';

const initialState = {
  error: null,
  unreadCount: 0,
  notifications: [],
  getUnreadCountTs: null,
  getNotificationsTs: null,
};

const NotificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case reducerConstant.getNotificationsSuccess:
      const getNotificationsSuccessResponse = action.payload.response;
      return {
        ...state,
        error: null,
        getNotificationsTs: !getNotificationsSuccessResponse.length
          ? state.getNotificationsTs
          : Date.now(),
        notifications: [
          ...state.notifications,
          ...getNotificationsSuccessResponse,
        ],
      };

    case reducerConstant.getNotificationsFailed:
      return {
        ...state,
        error: action.payload.message,
        getNotificationsTs: Date.now(),
      };
    case reducerConstant.getUnreadNotificationsCountSuccess:
      return {
        ...state,
        getUnreadCountTs: Date.now(),
        unreadCount: get(action.payload, 'response.count', 0) || 0,
      };
    case reducerConstant.notificationsMarkAsReadSuccess:
      const readNotification = state.notifications.map((notification) => {
        return { ...notification, read: 1 };
      });
      return {
        ...state,
        notifications: readNotification,
      };
    case 'persist/REHYDRATE':
      return {
        ...state,
        unreadCount:
          get(action.payload, 'notificationsReducer.unreadCount', 0) ||
          state.unreadCount,
        getUnreadCountTs:
          get(action.payload, 'notificationsReducer.getUnreadCountTs', null) ||
          state.getUnreadCountTs,
      };

    default:
      return state;
  }
};

export default NotificationsReducer;
